module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteBienvenue.ab030897.svg";